import { useRef, useState } from 'react';

import { FullscreenOutlined, PlayCircleOutlined } from '@ant-design/icons';

type Props = {
    src: string;
    width: string | number;
    height: string | number;
    loop?: boolean;
};

export const VideoSlide = ({ src, width = '100%', height = 300, loop = false }: Props) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const [showIndicator, setShowIndicator] = useState(true);

    const togglePlay = () => {
        if (!videoRef.current) return;
        if (videoRef.current.paused) {
            videoRef.current.play();
        } else {
            videoRef.current.pause();
        }
    };

    const handlePlay = () => {
        setShowIndicator(true);
        setTimeout(() => setShowIndicator(false), 500);
    };

    const handlePause = () => {
        setShowIndicator(true);
    };

    const handleFullscreen = () => {
        if (!containerRef.current) return;
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            containerRef.current.requestFullscreen().catch((err) => console.error(err));
        }
    };

    return (
        <div
            ref={containerRef}
            style={{
                position: 'relative',
                width,
                height,
                backgroundColor: 'black',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
            }}
            onClick={togglePlay}
        >
            <video
                ref={videoRef}
                src={src}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                preload="metadata"
                onPlay={handlePlay}
                onPause={handlePause}
                loop={loop}
            />
            {showIndicator && (
                <PlayCircleOutlined
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        fontSize: '3rem',
                        color: 'white',
                        pointerEvents: 'none',
                        opacity: 0.8,
                        transition: 'opacity 0.3s',
                    }}
                />
            )}
            <FullscreenOutlined
                onClick={(e) => {
                    e.stopPropagation();
                    handleFullscreen();
                }}
                style={{
                    position: 'absolute',
                    bottom: 20,
                    right: 10,
                    fontSize: '1.5rem',
                    color: 'white',
                    cursor: 'pointer',
                    opacity: 0.8,
                }}
            />
        </div>
    );
};
